export default __webpack_public_path__ + "static/media/background-effaciliti.bb7b8f91.jpg";